<script>
import MarkerClusterer from "@googlemaps/markerclustererplus";

export default {
  name: "GoogleMapCluster",
  props: {
    map: {
      type: Object,
      required: true,
    },
    markers: {
      type: Array,
      required: true,
    },
    clusterPath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cluster: null,
    };
  },
  mounted() {
    if (this.markers.length > 0) {
      this.cluster = new MarkerClusterer(this.map, this.markers, {
        enableRetinaIcons: true,
        imagePath: `${this.clusterPath}/m`,
        clusterClass: "cluster-custom",
      });
    }
  },
  render(h) {
    return h();
  },
};
</script>

<style lang="scss">
@import "~styles/global";

.cluster-custom {
  display: flex;
  align-items: center;

  * {
    color: $white;
    @include header-font-bold;
  }
}
</style>
